import React from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncSelect, Select, ChakraStylesConfig } from 'chakra-react-select';

const selectChakraStyles: ChakraStylesConfig = {
    control: (provided: any) => ({
        ...provided,
        border: 'none',
        borderRadius: '0',
        borderBottom: '1px solid var(--chakra-colors-gray-200)'
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        bg: 'transparent',
        px: 2,
        cursor: 'inherit'
    }),
    indicatorSeparator: (provided: any) => ({
        ...provided,
        display: 'none'
    })
};

export function AsyncSelector(props: {
    name: string;
    defaultInputValue: string;
    onChange: any;
    service: any;
    filter?: Record<string, any>;
    placeholder?: string;
    clearable?: boolean;
}): React.ReactElement {
    const { t } = useTranslation();
    let searchTimer: any;

    return (
        <AsyncSelect
            name={props.name}
            focusBorderColor='none'
            placeholder={props.placeholder || t('form.typeToSearch')}
            chakraStyles={selectChakraStyles}
            defaultInputValue={props.defaultInputValue}
            onChange={props.onChange}
            escapeClearsValue={props.clearable || false}
            isClearable={props.clearable || false}
            loadOptions={(inputValue, callback) => {
                clearTimeout(searchTimer);
                searchTimer = setTimeout(() => {
                    const filters = { ...props.filter, identifier: inputValue };
                    props.service.search(filters).then((res: any) => {
                        const data = res.map((l: any) => {
                            return {
                                value: l.id,
                                label: l.name || l.externalId
                            };
                        });
                        callback(data);
                    });
                }, 300);
            }}
        />
    );
}

export function Selector(props: {
    name: string;
    defaultInputValue?: any;
    onChange: any;
    placeholder?: string;
    options: Record<string, any>[];
    clearable?: boolean;
    isMulti?: boolean;
}): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Select
            name={props.name}
            focusBorderColor='none'
            placeholder={props.placeholder || t('form.typeToSearch')}
            chakraStyles={selectChakraStyles}
            defaultInputValue={props.defaultInputValue}
            onChange={props.onChange}
            options={props.options}
            isMulti={props.isMulti || false}
            escapeClearsValue={props.clearable || false}
            isClearable={props.clearable || false}
        ></Select>
    );
}
